import { DefaultButton, PrimaryButton, TooltipHost } from "@fluentui/react";
import React, { useContext, useEffect, useState } from "react";
import "../../../../../components/Modal/styles/ModalFooterCss.css";
import themeContext from "../../../../../context/theme/ThemeContext";
import { DownIcon } from "@fluentui/react-icons-mdl2";

const PeerReviewModalFooter = (props) => {
  const { getThemeColor } = useContext(themeContext);
  const isViewer = false;
  const [showContinueButton, setShowContinueButton] = useState(false);

  useEffect(() => {
    let timeOut = null;
    if (!showContinueButton) {
      timeOut = setTimeout(() => {
        setShowContinueButton(true);
      }, 1000);
    }

    return () => clearTimeout(timeOut);
  }, []);

  return (
    <>
      <div
        className="modal-footer-container"
        style={{
          background: !isViewer ? getThemeColor("modal-header-footer") : "#222",
        }}
      >
        <div className="modal-footer-buttons">
          {props.SecondaryButtonList &&
            props.SecondaryButtonList.map((obj, index) => {
              return obj.tooltip ? (
                <TooltipHost key={index} content={obj.tooltip}>
                  <PrimaryButton
                    text={obj.title}
                    style={{ marginRight: "8px", marginLeft: "8px" }}
                    disabled={(obj.disabled ?? false) || !showContinueButton}
                    onClick={obj.onclick}
                    onRenderIcon={() => obj.icon}
                  />
                </TooltipHost>
              ) : (
                <PrimaryButton
                  key={index}
                  text={obj.title}
                  style={{ marginRight: "8px", marginLeft: "8px" }}
                  disabled={(obj.disabled ?? false) || !showContinueButton}
                  onClick={obj.onclick}
                  onRenderIcon={() => obj.icon}
                />
              );
            })}
        </div>
        <div className="modal-footer-buttons">
          {props.DefaultButtonList &&
            props.DefaultButtonList.map((obj, index) => (
              <DefaultButton
                key={index}
                text={obj.title}
                style={{
                  marginRight: "8px",
                }}
                disabled={
                  obj.disabled != null && obj.disabled != undefined
                    ? obj.disabled
                    : false
                }
                onClick={obj.onclick}
              />
            ))}
          {props.PrimaryButtonList &&
            props.PrimaryButtonList.map((obj, index) => {
              return obj.tooltip ? (
                <TooltipHost content={obj.tooltip}>
                  <PrimaryButton
                    key={index}
                    text={obj.title}
                    style={{
                      marginRight: "8px",
                    }}
                    disabled={
                      (obj.disabled != null && obj.disabled != undefined
                        ? obj.disabled
                        : false) || !showContinueButton
                    }
                    onClick={obj.onclick}
                  />
                </TooltipHost>
              ) : (
                <PrimaryButton
                  key={index}
                  text={obj.title}
                  style={{
                    marginRight: "8px",
                  }}
                  disabled={
                    (obj.disabled != null && obj.disabled != undefined
                      ? obj.disabled
                      : false) || !showContinueButton
                  }
                  onClick={obj.onclick}
                />
              );
            })}
        </div>
      </div>
    </>
  );
};

export default PeerReviewModalFooter;
